import { waitForImageLoaded } from '../utils/utils.js';
import { initModal, displayModal } from '../modal/modal.js';

document
  .querySelectorAll('.text .illustrationContainer .miniature')
  .forEach((element) => {
    // On s'assure ici que le texte prendra au max la taille de l'image
    // Cela évite soit que le texte soit plus large que l'image et agrandisse le bloc
    // soit que le texte soit tronqué bien avant la fin du bloc à cause que l'image est trop grande
    const imageElement = element.querySelector('img');

    waitForImageLoaded(imageElement, () => {
      const maxWidth = imageElement.offsetWidth;
      if (maxWidth) {
        const updateLegendeWidth = () => {
          let maxFixedWidth;
          if (window.matchMedia('(max-width: 1279px)').matches) {
            maxFixedWidth = 'calc(100vw - 7rem)';
          } else {
            maxFixedWidth = '50vw';
          }

          element.querySelector(
            '.legende',
          ).style.maxWidth = `min(${maxWidth}px, ${maxFixedWidth})`;
        };

        let currentTimeout;
        window.addEventListener('resize', () => {
          if (currentTimeout) {
            // On évite d'appeler la fonction checkImageSize trop souvent
            window.clearTimeout(currentTimeout);
          }

          currentTimeout = setTimeout(() => updateLegendeWidth(), 300);
        });
        updateLegendeWidth();
      }
    });
  });

document.querySelectorAll('.richtext-wrapper').forEach((element) => {
  const modal = element.querySelector('.miniature-modal-wrapper .modal');
  initModal(modal);
  element
    .querySelectorAll('.illustrationContainer .miniature img')
    .forEach((imgEl) => {
      // Au clic, on souhaite afficher l'image taille réelle et non faire une redirection
      imgEl.addEventListener('click', (e) => {
        const srcPleinEcran = e.target.getAttribute('data-src-plein-ecran');
        if (!srcPleinEcran) {
          return;
        }
        // On bloque la redirection
        e.preventDefault();

        // Création des éléments
        const imgLink = modal.querySelector('.miniature-modal-img-link');
        imgLink.href = e.target.closest('a').href;

        const img = modal.querySelector('.miniature-modal-img');
        img.src = srcPleinEcran;

        const titre = modal.querySelector('.miniature-modal-title');
        titre.textContent = imgEl.getAttribute('alt');

        const link = modal.querySelector('.miniature-modal-link');
        link.href = e.target.closest('a').href;

        displayModal(modal);
      });
    });
});
